module.exports = __webpack_public_path__ + "static/media/withkids.75880872.svg";